import React from 'react';
import { useFormContext } from 'react-hook-form';
import classnames from 'classnames';
import { useFeature } from 'flagged';
import ControlledCheckbox from '@/components/common/form/ControlledCheckbox';
import ConstituentExportFieldName from '@/constants/constituents/ConstituentExportFieldName';
import FeatureFlags from '@/constants/system/FeatureFlags';
import translate from '@/lib/intl/translate';

export default function CsvExportCustomFields() {
  const { control } = useFormContext();
  const hasHouseholdEnhancements = useFeature(
    FeatureFlags.HOUSEHOLD_ENHANCEMENTS,
  );

  return (
    <div
      className={classnames('my-2', {
        'pr-10': hasHouseholdEnhancements,
      })}
    >
      <ControlledCheckbox
        label={
          hasHouseholdEnhancements ? (
            <div className="ml-3">
              <h3 className="text-text-primary type-body2">
                {translate('CONSTITUENT_EXPORT_CUSTOM_FIELDS')}
              </h3>
              <div className="mt-1 text-text-secondary type-caption1">
                {translate('CONSTITUENT_EXPORT_CUSTOM_FIELDS_DESCRIPTION')}
              </div>
            </div>
          ) : (
            translate('CONSTITUENT_INCLUDE_ALL_CUSTOM_FIELDS')
          )
        }
        name={ConstituentExportFieldName.CUSTOM_FIELDS}
        control={control}
        color="primary"
      />
    </div>
  );
}
